import React, { useEffect, useState } from "react";
// import ITskills from "../CandidateProfileSlice/ITskills/ITskills";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Flex } from "@chakra-ui/react";
import { ArrowRightIcon, ArrowLeftIcon } from "@chakra-ui/icons";
import { useSelector } from "react-redux";
import { selectITskills } from "../CandidateProfileSlice/ITskills/ITskillSlice";
import ITskillsCandidateProfile from "../CandidateProfileSlice/ITskills/ITskillsCandidateProfile";

function ITSkills() {
  const navigate = useNavigate();
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(null);

  useEffect(() => {
    const savedValue = localStorage.getItem("isCurrentlyWorking");
    if (savedValue) {
      setIsCurrentlyWorking(savedValue);
    }
  }, []);
  // console.log("isCurrentlyWorking", isCurrentlyWorking)

  const handleNext = () => {
    if (isCurrentlyWorking === "true") {
      navigate("/candidate-profile/experience");
    } else {
      navigate("/candidate-profile/job-preferences");
    }
  };

  const handlePrevious = () => {
    navigate("/candidate-profile/education");
  };

  return (
    <div>
      <Box minH="calc(100vh - 200px)" p={4} borderradius="md">
        {/* <ITskills /> */}
        <ITskillsCandidateProfile />

        <div className="w-full flex flex-wrap justify-center gap-2 mt-5">
          <Flex
            width={{
              base: "full",
              sm: "md",
              md: "lg",
              lg: "xl",
              xl: "4xl",
            }}
            justifyContent="space-between"
            gap={4}
          >
            <Button
              leftIcon={<ArrowLeftIcon />}
              colorScheme="blue"
              variant="outline"
              onClick={handlePrevious}
            >
              Previous
            </Button>
            <Button
              rightIcon={<ArrowRightIcon />}
              colorScheme="blue"
              onClick={handleNext}
            >
              Next
            </Button>
          </Flex>
        </div>
      </Box>
    </div>
  );
}

export default ITSkills;